import React, { useContext } from 'react'
import Parser from 'html-react-parser';
import { FormContext } from '../../FormContext';

const Note = ({field_label,field_column}) => {
    const { formAdmin, formAdminNoteEnable } = useContext(FormContext);
   
    return (
        <>
        {(!formAdmin ||formAdminNoteEnable) && <div className={`${field_column? field_column:'col-sm-12'} `} style={{ marginBottom: "3rem" }}>
        {/* {(!formAdmin ) && <div className={`${field_column? field_column:'col-sm-12'} `} style={{ marginBottom: "3rem" }}> */}
            {Parser(field_label)}
        </div>
        }
        </>
    )
}

export default Note
